import {
  BarChartInfoWrapper,
  CustomChartComponent,
  Separator,
  SwitchContentWrapper,
  Title,
} from '../styled'

import React from 'react'
import { ProductPageComponentProps } from '../../../interfaces'
import { CustomBarChart } from 'components/charts/bar-chart'

export const PerformanceContent: React.FC<Pick<ProductPageComponentProps, 'store'>> = ({
  store,
}) => {
  const { product, dailyStats } = store

  return (
    <SwitchContentWrapper>
      <div id="tour-chart">
        <Title>Performance</Title>
        <>
          <CustomChartComponent store={store} />
        </>
      </div>
      <Separator />
      <BarChartInfoWrapper id="tour-returns">
        <Title>Returns</Title>
        <CustomBarChart product={product} dailyStats={dailyStats} />
      </BarChartInfoWrapper>
    </SwitchContentWrapper>
  )
}

export default PerformanceContent
